import React, { useEffect, useState } from 'react';
import './EventModal.scss';
import { Modal } from 'antd';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setSelectedEvent } from 'store/features/event-slice';
import { Button } from '../../components/Button';
import { dateDifference, dateDifferenceInMinutes, isEventDisabled, isEventLive, isTodayOrTomorrow } from '../../helpers';

const TIMEOUT_1_SECOND = 1000;

export const EventModal = () => {
  const dispatch = useAppDispatch();
  const selectedEvent = useAppSelector(state => state.event.selectedEvent);

  const [currentTime, setCurrenTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrenTime(new Date());
    }, TIMEOUT_1_SECOND);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const isPast = isEventDisabled(false, selectedEvent?.end!);
  const isLive = isEventLive(selectedEvent?.start!, selectedEvent?.end!);

  const isButtonDisabled = !isLive && dateDifferenceInMinutes(currentTime, new Date(selectedEvent?.start!)) > 15;

  return (
    <Modal
      title={selectedEvent?.summary}
      open={selectedEvent !== null}
      className={'turing-modal'}
      centered
      footer={null}
      destroyOnClose
      onCancel={() => dispatch(setSelectedEvent(null))}>
      {selectedEvent && (
        <p>
          {isTodayOrTomorrow(new Date(selectedEvent?.start))} {new Date(selectedEvent?.start).toLocaleTimeString().substring(0, 5)} -{' '}
          {new Date(selectedEvent?.end).toLocaleTimeString().substring(0, 5)}
        </p>
      )}
      <br />
      {!isPast && !isLive && selectedEvent && <p>Starts in: {dateDifference(currentTime, new Date(selectedEvent.start))}</p>}
      {isLive && <p className="live-text">Event is happening! Quick, join, join, join!</p>}
      {isPast ? (
        <p>Event already happened </p>
      ) : (
        <Button href={selectedEvent?.url} disabled={isButtonDisabled} text={`Join meeting`} className="full-width" />
      )}
    </Modal>
  );
};
